/**
 * A mirror of the server's plan limits, for telling people what they can do
 * BEFORE they fill in a form.
 *
 * The server is the authority: it enforces these numbers and will refuse a
 * request that exceeds them regardless of what this file says. Everything
 * here exists to make the interface honest in advance rather than to gate
 * anything. If the two ever disagree, the server wins and the user sees its
 * message.
 *
 * Keep in step with libs/common/farmgate_common/plans.py.
 */

export const PLAN_LIMITS = {
  Free: { maxAlerts: 2, maxHoldings: 3 },
  Standard: { maxAlerts: 20, maxHoldings: null },
  Premium: { maxAlerts: null, maxHoldings: null },
};

const UNLIMITED = { maxAlerts: null, maxHoldings: null };

/** Limits for a user object from AuthContext. Admins and unknowns get room. */
export function limitsFor(user) {
  if (!user) return UNLIMITED;
  if (user.role === 'admin') return UNLIMITED;
  return PLAN_LIMITS[user.plan] || PLAN_LIMITS.Free;
}

/** True when one more would be refused. */
export const atLimit = (count, ceiling) => ceiling != null && count >= ceiling;

/** "2 of 2 used" for a capped plan, empty string when unlimited. */
export function usageLabel(count, ceiling, noun) {
  if (ceiling == null) return '';
  return `${count} of ${ceiling} ${noun} used`;
}

/** A 402 from the API means a plan ceiling, not a mistake by the user. */
export const isPlanLimit = (err) => err?.status === 402;

// Which plans include the analytics workspace in full. Free can open those
// pages, it just sees less of the data and none of the tools, so this asks
// "should we offer an upgrade here", never "may they enter".
const ANALYTICS_PLANS = ['Standard', 'Premium'];

export function hasAnalytics(user) {
  if (!user) return false;
  if (user.role === 'admin') return true;
  return ANALYTICS_PLANS.includes(user.plan);
}
